import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const ContentBox = ({ classes, title, value, isFirst, boldTitle }) => (
  <div className={`${classes.root} ${!isFirst && classes.borderLeft}`}>
    <Typography className={boldTitle && classes.bold}>{title}</Typography>
    <Typography>{value}</Typography>
  </div>
);

ContentBox.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  isFirst: PropTypes.bool,
  boldTitle: PropTypes.bool,
};

ContentBox.defaultProps = {
  isFirst: false,
  boldTitle: false,
};

export default withStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0',
    padding: '0 20px',
  },
  bold: {
    fontWeight: 600,
  },
  borderLeft: {
    borderLeft: `1px solid ${theme.palette.primary.borderColor}`,
  },
}))(ContentBox);
